import './CommonButton.scss'

/**COMMON BUTTON WITH DYNAMIC PROPS */
const CommonButton = (props) => {
  return (
    <button
      onClick={props?.onClick}
      type={props?.type}
      className={`btn-style ${props.className} ${props.fluid ? 'w-100' : ''} ${props.transparent ? 'transparent' : ''}`}
      disabled={props?.disabled}
    >
      {props.onlyIcon && <span className="onlyIcon">{props.onlyIcon}</span>}
      {props.title}
      {props.rightIcon && <span className="rightIcon">{props.rightIcon}</span>}
      {props.btnIcon && <img src={props.btnIcon} alt="icon" className="" />}
      {/* {props.onlyIcon && <span className="onlyIcon">{props.onlyIcon}</span>} */}
    </button> 
  )
}

export default CommonButton
